export { default } from './LiveWindBarGraph';
